import { render, staticRenderFns } from "./ed-loading-bars.vue?vue&type=template&id=0603f46a&scoped=true&"
import script from "./ed-loading-bars.ts?vue&type=script&lang=ts&"
export * from "./ed-loading-bars.ts?vue&type=script&lang=ts&"
import style0 from "./ed-loading-bars.scss?vue&type=style&index=0&id=0603f46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0603f46a",
  null
  
)

export default component.exports